/* eslint max-len:0 */
const Spanish = {
    _language: 'spanish',
    _language_short: 'es',
    agentWelkomMessage: 'Bienvenido. Haz tu pregunta aquí.',
    conversationTimestampHeaderFormat: 'HH:mm',
    couldNotConnect: 'No se pudo conectar. Puedes {retry}',
    couldNotConnectInner: 'intentar conectarte ahora',
    couldNotConnectWithRetry: 'No se pudo conectar. Seguiremos intentando, o puedes {retry}.',
    couldNotConnectWithRetryInner: 'intenta ahora',
    headerText: '¿Cómo podemos ayudarte?',
    imageClickToReload: 'Haz clic para recargar la imagen.',
    imageClickToView: 'Haz clic para ver la imagen de {size}.',
    imagePreviewNotAvailable: 'Vista previa no disponible.',
    inputPlaceholder: 'Escribe aquí, presiona <enter> para enviar.',
    inputPlaceholderBlocked: 'Completa el formulario de arriba...',
    introAppText: 'Envía tu mensaje abajo o desde tu canal favorito.',
    introductionText: 'Haz tu pregunta aquí.',
    actionPaymentCompleted: 'Pago recibido.',
    actionPaymentError: 'Ocurrió un error al procesar el pago. <br> Intenta nuevamente o usa otra tarjeta.',
    actionPostbackError: 'Ocurrió un error al procesar tu acción. Por favor, intenta nuevamente.',
    clickToRetry: 'Mensaje no entregado. Por favor, intenta nuevamente.',
    clickToRetryForm: 'Formulario no enviado. Haz clic en cualquier parte del formulario para reintentar.',
    connectNotificationText: 'Espera una respuesta o elige la aplicación con la que te gustaría continuar.',
    connectNotificationSingleText: 'Espera una respuesta o elige la aplicación con la que te gustaría continuar.',
    connectNotificationSingleButtonText: 'Activar notificaciones de <name>',
    connectNotificationOthersText: 'otros',
    emailChangeAddress: 'Cambiar mi correo electrónico',
    emailDescription: 'Para ser notificado por correo electrónico cuando recibas una respuesta, ingresa tu dirección de correo.',
    emailFieldLabel: 'Tu correo electrónico',
    emailFieldPlaceholder: 'Tu dirección de correo electrónico',
    emailFormButton: 'Continuar',
    fetchHistory: 'Cargar más',
    fetchingHistory: 'Recuperando historial...',
    frontendEmailChannelDescription: 'Envíanos un correo y te responderemos lo antes posible.',
    invalidFileError: 'Solo se admiten imágenes. Elige un archivo con una extensión compatible (jpg, jpeg, png, gif o bmp).',
    lineChannelDescription: 'Escanea el código QR para hablar con nosotros a través de LINE.',
    locationNotSupported: 'Tu navegador no soporta los servicios de ubicación o están deshabilitados. Por favor, ingresa tu ubicación.',
    locationSecurityRestriction: 'Este sitio web no puede acceder a tu ubicación. Por favor, ingresa tu ubicación.',
    locationSendingFailed: 'No se pudo enviar la ubicación',
    locationServicesDenied: 'Este sitio web no puede acceder a tu ubicación. Permite el acceso en tu configuración o ingresa tu ubicación.',
    messageError: 'Ocurrió un error al enviar tu mensaje. Por favor, intenta nuevamente.',
    messageIndicatorTitlePlural: '({count}) Nuevos mensajes',
    messageIndicatorTitleSingular: '({count}) Nuevo mensaje',
    messageRelativeTimeDay: 'hace {value}d',
    messageRelativeTimeHour: 'hace {value}h',
    messageRelativeTimeJustNow: 'Justo ahora',
    messageRelativeTimeMinute: 'hace {value}m',
    messageTimestampFormat: 'h:mm A',
    messageSending: 'Enviando...',
    messageDelivered: 'Entregado',
    messengerChannelDescription: 'Conecta tu cuenta de Facebook para continuar a través de Facebook Messenger.',
    whatsappChannelDescriptionDesktop: '¿Iniciar o continuar tu conversación a través de WhatsApp? Haz clic en el enlace a continuación.',
    whatsappChannelDescriptionMobile: '¿Iniciar o continuar tu conversación a través de WhatsApp? Haz clic en el enlace a continuación.',
    whatsappLinkingError: 'Algo salió mal al conectarse. Por favor, intenta nuevamente.',
    notificationSettingsChannelsDescription: 'También puedes hablar con nosotros desde tu aplicación o servicio favorito.',
    notificationSettingsChannelsTitle: 'Otras aplicaciones',
    notificationSettingsConnected: 'Conectado',
    notificationSettingsConnectedAs: 'Conectado como {username}',
    prechatCaptureGreetingText: 'Hola 👋\nPara empezar, nos gustaría saber un poco más sobre ti:',
    prechatCaptureNameLabel: 'Tu nombre',
    prechatCaptureNamePlaceholder: 'Escribe tu nombre...',
    prechatCaptureEmailLabel: 'Correo electrónico',
    prechatCaptureEmailPlaceholder: 'nombre@empresa.com',
    prechatCaptureConfirmationText: '¡Gracias por eso! ¿En qué podemos ayudarte?',
    prechatCaptureMailgunLinkingConfirmation: 'Serás notificado aquí y por correo electrónico en {email} cuando respondamos.',
    sendButtonText: 'Enviar',
    settingsHeaderText: 'Configuraciones',
    smsBadRequestError: 'No pudimos conectar con este número. Intenta nuevamente o usa otro número.',
    smsCancel: 'Cancelar',
    smsChangeNumber: 'Cambiar mi número',
    smsChannelDescription: 'Conecta tu número SMS para continuar por SMS.',
    smsChannelPendingDescription: 'Revisa tus mensajes en {number} para confirmar tu número de teléfono.',
    smsContinue: 'Continuar',
    smsInvalidNumberError: 'Tu número de teléfono no es válido. Por favor, intenta nuevamente.',
    smsLinkCancelled: 'Vinculación a {appUserNumber} cancelada.',
    smsLinkPending: 'Pendiente',
    smsPingChannelError: 'Hubo un error al enviar un mensaje a tu número.',
    smsSendText: 'Envíame un mensaje',
    smsStartTexting: 'Empezar a enviar mensajes',
    smsTooManyRequestsError: 'Se solicitó una conexión para ese número recientemente. Intenta nuevamente en {minutes} minutos.',
    smsTooManyRequestsOneMinuteError: 'Se solicitó una conexión para ese número recientemente. Intenta nuevamente en 1 minuto.',
    smsUnhandledError: 'Algo salió mal. Por favor, intenta nuevamente.',
    tapToRetry: 'Mensaje no entregado. Presiona enter para reintentar.',
    tapToRetryForm: 'Formulario no enviado. Toca en cualquier parte del formulario para reintentar.',
    telegramChannelDescription: 'Conecta tu cuenta de Telegram para continuar a través de Telegram.',
    unsupportedMessageType: 'Tipo de mensaje no soportado.',
    unsupportedActionType: 'Tipo de acción no soportado.',
    linkError: 'Ocurrió un error al intentar generar un enlace para este canal. Por favor, intenta nuevamente.',
    viberChannelDescription: 'Conecta tu cuenta de Viber para continuar a través de Viber.',
    viberChannelDescriptionMobile: 'Conecta tu cuenta de Viber para ser notificado cuando recibas una respuesta y continuar la conversación en Viber. Para empezar, instala la aplicación de Viber y toca en Conectar.',
    viberQRCodeError: 'Ocurrió un error al obtener tu código QR de Viber. Por favor, intenta nuevamente.',
    wechatChannelDescription: 'Conecta tu cuenta de WeChat para ser notificado cuando recibas una respuesta y continuar la conversación en WeChat. Para empezar, escanea este código QR usando la aplicación de WeChat.',
    wechatChannelDescriptionMobile: 'Conecta tu cuenta de WeChat para ser notificado cuando recibas una respuesta y continuar la conversación en WeChat. Para empezar, guarda esta imagen del código QR y cárgala en <a href="weixin://dl/scan">escáner de código QR</a>.',
    wechatQRCodeError: 'Ocurrió un error al obtener tu código QR de WeChat. Por favor, intenta nuevamente.',
    fileTooLargeError: 'Límite de tamaño de archivo excedido ({size})',
    shareLocation: 'Compartir ubicación',
    uploadDocument: 'Subir documento',
    uploadInvalidError: 'Archivo no válido',
    fileTypeError: 'Tipo de archivo no soportado',
    formErrorInvalidEmail: 'El correo electrónico no es válido',
    formErrorNoLongerThan: 'Debe contener no más de ({characters}) caracteres',
    formErrorNoShorterThan: 'Debe contener al menos ({characters}) caracteres',
    formErrorUnknown: 'Esto no parece estar bien',
    formFieldSelectPlaceholderFallback: 'Elige uno...',
    uploadPhoto: 'Subir foto',
    uploadVirusError: 'Se detectó un virus en tu archivo y ha sido rechazado',
    shoutoutText: 'Iniciar un chat',
    cardClickText: 'Seleccionado'
};
export { Spanish };
